/* eslint-disable no-underscore-dangle */
/* eslint-disable no-bitwise */
/* eslint-disable no-magic-numbers */
import React, { useEffect, useMemo } from 'react'
import styles from './styles/app.module.scss'
import { useLocation, Outlet, useNavigate } from 'react-router-dom'
import { getRoute } from './router'
import MainLayout from '@/pages/main-layout/main-layout'
import { TOKEN_INVALID } from './event/user'
import { useEvent } from './event'
import { ApplyResponse } from '@/apis/product'
import { Modal, FloatingBubble } from 'antd-mobile'
import Event from '@/event'
import { APPLY_STATUS_MODAL } from '@/event/constant'
import { TOKEN } from '@/constants/storage'
import { Storage } from '@/utils/common-js'
// import RumSDK from '@arms/rum-browser'
import { initRumSDKInstance } from '@/hooks/useArmsCustomTracker'
import { useInitializeAdChannelCode } from '@/hooks/use-channel'
import { useTitleAndFavicon } from './hooks/title-and-favicon'
import { LoopOutline } from 'antd-mobile-icons'
import useDevAPI from './hooks/devApi'
import { useSensors } from './hooks/use-sensors'
import { useInitControl } from './hooks/initControl'
import { useAutoFormUseful } from './hooks/useAutoFormUseful'
import { useUserStore } from '@/store/user.store'
import { selectIsFormProcess5Channel, useAdChannelStore } from '@/store/adChannelCode.store'
import { getEnvironment } from './env'
import { reportWechatDomain, useRouteRapidJumpTracker } from '@/hooks/useArmsCustomTracker'
import { TEXT_CHAR_CODES, textByCharCodes } from '@/utils/char-text'


interface ApplyResponseType extends ApplyResponse {
  productName: string
}

const App: React.FC = () => {
  const { initSensors } = useSensors()
  // 针对各类平台进行埋点处理
  // useBuryingPoint()
  // 全局渠道管理和特殊渠道区分
  useInitializeAdChannelCode()
  // 全局管理title和favicon图标
  useTitleAndFavicon()
  // 项目初始化
  useInitControl()
  // 路由快速跳转监控埋点
  useRouteRapidJumpTracker()
  // 微信环境上报域名
  reportWechatDomain()
  const { reloadForm } = useDevAPI()
  const { channelValue, adChannelCode } = useAdChannelStore(state => state)
  const isFormProcess5Channel = useAdChannelStore(selectIsFormProcess5Channel)
  const location = useLocation()
  const navigate = useNavigate()
  const event = useEvent()
  // 是否已登录
  const isLoggedIn = useUserStore(state => state.isLoggedIn)
  // 用户信息
  const userInfo = useUserStore(state => state.userInfo)
  // let interval = useRef<ReturnType<typeof setInterval>>()
  // // 当前页面是否可见
  // const [visibilityState, setVisibilityState] = useState<'hidden' | 'visible'>('visible')

  // useEffect(() => {

  //   if (isLoggedIn) {

  //     if (interval.current) {
  //       clearInterval(interval.current)
  //     }

  //     interval.current = setInterval(() => {
  //       if (visibilityState === 'visible') {
  //         // 上报用户在线心跳
  //         activityApi.health()
  //       }
  //     // eslint-disable-next-line no-magic-numbers
  //     }, 5000)
  //   }

  //   return () => {
  //     clearInterval(interval.current)
  //   }
  // }, [isLoggedIn, visibilityState])

  // 监听页面是否可见
  // useEffect(() => {
  //   const visibilitychange = () => {
  //     setVisibilityState(document.visibilityState)
  //   }
  //   document.addEventListener('visibilitychange', visibilitychange)

  //   return () => {
  //     document.removeEventListener('visibilitychange', visibilitychange)
  //   }
  // }, [])

  const applyStatusModalCallBack = async (obj: ApplyResponseType) => {

    if (obj.applyStatus === 0) {
      Modal.alert({
        content: '该产品销售火爆，请关注其他商品或更换手机号登录后尝试',
        onConfirm: () => {
          // console.log('Confirmed')
        },
      })
    } else if (obj.applyStatus === 2) {
      const result = await Modal.confirm({
        content: textByCharCodes('该手机号已注册，点击确认跳转', TEXT_CHAR_CODES.xiazai, '页面'),
      })
      if (result) {
        navigate(`/inline-page?url=${obj.thirdpartyTargetUrl}${obj.productName ? `&productName=${obj.productName}` : ''}`)
      }
    }
  }

  useEffect(() => {
    // token 过期，退出登录
    event.on(TOKEN_INVALID, () => {
      useUserStore.getState().logout()
      navigate(`/getQuota${adChannelCode ? `?adChannelCode=${adChannelCode}` : ''}`)
    })

    Event.off(APPLY_STATUS_MODAL, applyStatusModalCallBack)
    Event.on(APPLY_STATUS_MODAL, applyStatusModalCallBack)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // 获取用户信息
    const getUserAsyncFn = async () => {
      await useUserStore.getState().getUserAsync(true)
    }

    Storage.get(TOKEN) && getUserAsyncFn().catch(() => {})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  // 是否需要显示主布局
  const hasMainLayout = useMemo(() => {
    const route = getRoute(location.pathname)
    return route ? route.hasMainLayout : false
  }, [location])

  // 阿里云实时应用监控
  const config = {
    pid: 'gndt3gpkvt@7dd815d50e50eb7',
    endpoint: 'https://gndt3gpkvt-default-cn.rum.aliyuncs.com',
    env: getEnvironment(),
    version: '1.0.3'
  }
  // npm形式
  useEffect(() => {
    // 清掉脏数据，实际数据从接口获取
    localStorage.removeItem('USER_INFO')
    initRumSDKInstance(rumSDK => rumSDK.init(config))
  }, [])

  // 阿里云实时应用监控
  useEffect(() => {
    if (userInfo?.uid) {
      try {
        initRumSDKInstance(rumSDK => {
          const sdkConfig = rumSDK.getConfig()
          rumSDK.setConfig({
            ...sdkConfig,
            user: {
              name: userInfo.uid.toString()
            }
          })
        })
      } catch (err) {
        console.error(err)
      }
    }
  }, [userInfo])

  const themeChange = (color: string, linearColor: string) => {
    document.documentElement.style.setProperty('--color-primary', color)
    document.documentElement.style.setProperty('--color-primary-r', parseInt(color.slice(1, 3), 16).toString())
    document.documentElement.style.setProperty('--color-primary-g', parseInt(color.slice(3, 5), 16).toString())
    document.documentElement.style.setProperty('--color-primary-b', parseInt(color.slice(5, 7), 16).toString())
    const linearGradient = `linear-gradient(108.61deg, ${linearColor} 3.46%, ${color} 97.1%) `
    document.documentElement.style.setProperty('--linear-gradient', linearGradient)
  }

  // 主题切换
  useEffect(() => {
    if (adChannelCode) {
      // 渠道皮肤
      switch (true) {
        case channelValue?.includes('financeBlueTheme'):
          themeChange('#0060f3', '#0B95FC')
          return
        case isFormProcess5Channel:
          themeChange('#0060f3', '#0B95FC')
          return
        case channelValue?.includes('shallowBlue'):
          themeChange('#29A8FF', '#9BD6FF')
          return
        case channelValue?.includes('halo'):
          themeChange('#0081FE', '#58B3FF')
          return
        case channelValue?.includes('huanbeitheme'):
          themeChange('#6EC2D0', '#A7E0E9')
          return
        case channelValue?.includes('chengyitongTheme'):
          themeChange('#6872FE', '#6872FE')
          return
        default:
          themeChange('#FF2C3E', '#FF606E')
      }
    }
  }, [channelValue, isFormProcess5Channel])

    // 神策埋点初始化
  useEffect(() => {
    initSensors()
  }, [])

  useAutoFormUseful()

  return <div className={styles.app} id="app">
    {
      hasMainLayout ? <MainLayout><Outlet /></MainLayout> : <Outlet />
    }
    {
      getEnvironment() !== 'prod' && <FloatingBubble
        axis="xy"
        magnetic="x"
        style={{
          '--initial-position-bottom': '60px',
          '--initial-position-right': '24px',
          '--edge-distance': '24px',
          '--z-index': "99999",
        }}
        onClick={reloadForm}
      ><LoopOutline fontSize={20} /></FloatingBubble>
    }
  </div>
}

export default App
